import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, MAX_FILE_SIZE_1MB } from '@/common/constants';

export const invoiceTemplateSchema = (isEdit = false) => {
    return (
        Yup.object({
            templateName: Yup.string()
                .trim()
                .required('Template name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            contactPerson: Yup.string()
                .trim()
                .required('Contact person is required')
                .max(255, 'Max length is 50 characters'),
            indonesiaBank: Yup.string()
                .trim()
                .required('Indonesia bank is required'),
            internationalBank: Yup.string()
                .trim()
                .required('International bank is required'),
            managerName: Yup.string()
                .trim()
                .required('Manager name is required')
                .max(50, 'Max length is 50 characters'),
            approvalFile: Yup.lazy((value) => {
                if (isEdit && typeof(value) === 'string'){
                    return Yup.string();
                } else {
                    return Yup.mixed().test('fileSize', 'File size is too large', (value: any) => {
                    if (value && (value as File).size > MAX_FILE_SIZE_1MB) {
                        return false;
                    }
                    return true;
                })
                .test('dimensions', 'Image max 500px by 500px', async (file: any) => {
                    if (!file) return isEdit;
                    return await validateImageDimensions(file);
                })
                }
            }),
        }));
}

const validateImageDimensions = (file: File | null): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        if (!file) {
            resolve(false);
            return;
        }

        const reader = new FileReader();
        const image = new Image();

        reader.onload = (event: ProgressEvent<FileReader>) => {
            if (event.target) {
                image.src = event.target.result as string;
            }
        };

        image.onload = () => {
            const { width, height } = image;
            if (width <= 500 && height <= 500) {
                resolve(true);
            } else {
                resolve(false);
            }
        };

        image.onerror = () => {
            reject(new Error('Invalid image'));
        };

        reader.readAsDataURL(file);
    });
};